"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlateChart = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("@components/common");
exports.PlateChart = (0, styled_components_1.default)(common_1.Plate).attrs(props => ({
    padding: 0,
    margin: '0 0 20px 0',
    className: 'plate-chart'
})) `
  position: relative;
`;
